import React from "react";
import { Modal } from "react-bootstrap";
import qr from "../../photos/qr.jpg";
const NonDismissableModal = ({ show = () => {} }) => {
  return (
    <>
      <Modal show={show}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Visit on your mobile device</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong>
            We currently only support mobile. Scan below to see our mobile site
            :)
          </strong>
        </Modal.Body>
        <img src={qr} />
      </Modal>
    </>
  );
};
export default NonDismissableModal;
